import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import user from "../../static/user.svg";
import profile from "../../static/DropDown/dd-profile.svg";
import address from "../../static/DropDown/dd-address.svg";
import contact from "../../static/DropDown/dd-contact.svg";
import wishlist from "../../static/DropDown/dd-wishlist.svg";
import orders from "../../static/DropDown/dd-orderes.svg";
import { getLocalData } from "../../utils/localStorage";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import { useSelector,useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Col, Row } from "react-bootstrap";
import { updateUser } from "../../redux/userSlice";
import User from "../SvgComponents/User";


function UserDropDown() {


  const userData = useSelector((state) => state.user.userData);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (getLocalData("user-info")?.userToken?.length > 0) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
    //console.log("data changed" + loggedIn);
  }, [getLocalData("user-info")?.userToken]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <>
      {!loggedIn && (
        <Link to="/login" className="round-btn-header">
          <User/>
        </Link>
      )}

      {loggedIn && (
        <>
          <Tooltip title="">
            <span className="round-btn-header" onClick={handleClick}>
            <User/>
            </span>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <li>
                Welcome back, {userData.name}
              </li>
              <Divider />
            <Link className="userDD-li" to="user">
              <MenuItem>
                 <Row className="userDD-Row">
                  <Col md={2} className="userDD-icon">
                    <img src={profile} alt="profile" />
                  </Col>
                  <Col md={10}>
                  My Profile
                  </Col>
                 </Row>
              </MenuItem>
            </Link>
            <Link  className="userDD-li" to="user/orders">
              <MenuItem >
                 <Row className="userDD-Row">
                  <Col md={2} className="userDD-icon">
                    <img src={orders} alt="Orders"  />
                  </Col>
                  <Col md={10}>
                  Orders
                  </Col>
                 </Row>
              </MenuItem>
            </Link>
            <Link  className="userDD-li" to="wishlist">
              <MenuItem>
                 <Row className="userDD-Row">
                  <Col md={2} className="userDD-icon">
                    <img src={wishlist} alt="Wishlist" />
                  </Col>
                  <Col md={10}>
                  Wishlist
                  </Col>
                 </Row>
              </MenuItem>
            </Link>
            <Link  className="userDD-li" to="user">
              <MenuItem>
                 <Row className="userDD-Row">
                  <Col md={2} className="userDD-icon">
                    <img src={contact} alt="Contact" />
                  </Col>
                  <Col md={10}>
                  Contact Us
                  </Col>
                 </Row>
              </MenuItem>
            </Link>
            <Divider />
            <Link  className="userDD-li" to="user/address/">
              <MenuItem>
                 <Row className="userDD-Row">
                  <Col md={2} className="userDD-icon">
                    <img src={address} alt="Adresses" />
                  </Col>
                  <Col md={10}>
                  Saved Adresses
                  </Col>
                 </Row>
              </MenuItem>
            </Link>
            
            <li>
            <button className="btn btn-danger btn-logout" onClick={() => {
                localStorage.clear();
                dispatch(updateUser({}))
                navigate("/");
              }}>
              LOGOUT
              </button>
            </li>
            <MenuItem
              
            >
              
              
            </MenuItem>
          </Menu>
        </>
      )}
    </>
  );
}

export default UserDropDown;
